import { createApiSlice } from 'app/createApiSlice'
import {
  API_FINDORA_PRODUCT_PROCESS,
  API_FINDORA_PRODUCT_PROCESS_LIST,
} from 'utils/apiList'

export const productMappingListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'productMappingList/api',
  endpoints(builder) {
    return {
      fetchFindoraProductProcessList: builder.query({
        query({
          page = 0,
          size = 10,
          sortby = 'product_process_name',
          sortdir = 'ASC',
          s,
        }) {
          return {
            url: `/${API_FINDORA_PRODUCT_PROCESS_LIST}`,
            params: {
              page,
              size,
              sortby,
              sortdir,
              s,
            },
          }
        },
      }),
      getProductProcess: builder.query({
        query({ page = 0, size = 9999 }) {
          return {
            url: `${API_FINDORA_PRODUCT_PROCESS}`,
            params: {
              page,
              size,
            },
            method: 'GET',
          }
        },
      }),
      postAddProcess: builder.mutation({
        query(payload) {
          return {
            url: API_FINDORA_PRODUCT_PROCESS,
            method: 'POST',
            body: payload,
          }
        },
      }),
      removeProcess: builder.mutation({
        query(id) {
          return {
            url: `${API_FINDORA_PRODUCT_PROCESS}/${id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export const {
  useFetchFindoraProductProcessListQuery,
  useLazyFetchFindoraProductProcessListQuery,
  useGetProductProcessQuery,
  usePostAddProcessMutation,
  useRemoveProcessMutation,
} = productMappingListApiSlice
